var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "refund-page" }, [
    _c("header", { staticClass: "page-header" }, [
      _c(
        "button",
        {
          staticClass: "back-button",
          attrs: { type: "button", "aria-label": "返回" },
          on: { click: _vm.goBack },
        },
        [_vm._v(" ‹ ")]
      ),
      _c("h1", [_vm._v("退款詳情")]),
    ]),
    _c(
      "main",
      { staticClass: "page-content" },
      [
        _vm.loading
          ? _c(
              "section",
              {
                staticClass: "card refund-card refund-skeleton",
                attrs: { "aria-label": "退款資料載入中" },
              },
              [
                _c("div", { staticClass: "skeleton-line skeleton-status" }),
                _c("div", { staticClass: "skeleton-line skeleton-amount" }),
                _c("div", { staticClass: "divider" }),
                _c("div", { staticClass: "skeleton-line skeleton-product" }),
                _c("div", {
                  staticClass: "skeleton-line skeleton-product short",
                }),
                _c("div", { staticClass: "divider" }),
                _vm._l(3, function (index) {
                  return _c("div", {
                    key: index,
                    staticClass: "skeleton-line skeleton-meta",
                  })
                }),
                _c("div", { staticClass: "skeleton-line skeleton-note" }),
              ],
              2
            )
          : _vm._l(_vm.refundList, function (item) {
              return _c(
                "section",
                {
                  key: item.id || item.refundNumber,
                  staticClass: "card refund-card",
                },
                [
                  _c("div", { staticClass: "refund-status" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.statusStr[item.status] || item.status) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "refund-amount" }, [
                    _c("span", [_vm._v("退款金額：")]),
                    _c("strong", [_vm._v("NT$ " + _vm._s(item.price))]),
                  ]),
                  _c("div", { staticClass: "divider" }),
                  _vm._l(item.orderRefundItemList || [], function (refundItem) {
                    return _c("order-detail-spu-list-item", {
                      key: refundItem.id,
                      attrs: { "item-data": refundItem, detail: _vm.detail },
                    })
                  }),
                  _c("div", { staticClass: "divider" }),
                  _c("dl", { staticClass: "refund-meta" }, [
                    _c("div", [
                      _c("dt", [_vm._v("退款原因")]),
                      _c("dd", [_vm._v(_vm._s(item.reason || ""))]),
                    ]),
                    _c("div", [
                      _c("dt", [_vm._v("售後單號")]),
                      _c("dd", [_vm._v(_vm._s(item.refundNumber || ""))]),
                    ]),
                    _c("div", [
                      _c("dt", [_vm._v("退款時間")]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.formatDate(item.createTime))),
                      ]),
                    ]),
                  ]),
                  _c("p", { staticClass: "refund-note" }, [
                    _vm._v(
                      " 備註：退款金額根據用戶實際收到之商品和數量，重新計算金額。 "
                    ),
                  ]),
                ],
                2
              )
            }),
        _c("h2", [_vm._v("訂單內容")]),
        _c(
          "section",
          { staticClass: "card goods-card" },
          [
            !_vm.loading && _vm.hasPackage
              ? _c("order-package-widget", { attrs: { detail: _vm.detail } })
              : !_vm.loading
              ? _c("refund-spu-list-widget", { attrs: { detail: _vm.detail } })
              : _vm._e(),
            _c("order-price-list", { attrs: { detail: _vm.detail } }),
          ],
          1
        ),
        _vm._m(0),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "formula-note" }, [
      _c("span", [_vm._v("退款公式為")]),
      _c("span", [_vm._v("A=原支付金額")]),
      _c("span", [_vm._v("B=依實際收到之商品和數量，重新計算最優惠活動")]),
      _c("span", [_vm._v("退款金額=A-B-運費-購物袋")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }